export default function Industries() {
  const industries = [
    {
      icon: 'ri-home-gear-line',
      title: 'Home Services',
      description: 'AI workflows that reduce missed calls, streamline scheduling, and improve job profitability.',
      image: 'https://public.readdy.ai/ai/img_res/6a31a17b5ef0235e0c5e800f670f8f6e.jpg'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Health & Wellness',
      description: 'Operational intelligence for clinics focused on patient experience, retention, and growth.',
      image: 'https://readdy.ai/api/search-image?query=modern%20healthcare%20clinic%20interior%20with%20clean%20design%2C%20medical%20professionals%20using%20digital%20systems%2C%20patient-centered%20environment%20with%20calming%20colors%2C%20professional%20wellness%20atmosphere%20with%20technology%20integration&width=600&height=400&seq=industry-health-001&orientation=landscape'
    },
    {
      icon: 'ri-building-2-line',
      title: 'Real Estate & Insurance',
      description: 'Systems that support faster decisions, cleaner pipelines, and scalable operations.',
      image: 'https://readdy.ai/api/search-image?query=professional%20real%20estate%20office%20with%20modern%20architecture%2C%20digital%20property%20displays%20and%20analytics%20dashboards%2C%20clean%20contemporary%20workspace%20with%20glass%20and%20steel%20elements%2C%20business%20professional%20atmosphere&width=600&height=400&seq=industry-realestate-001&orientation=landscape'
    },
    {
      icon: 'ri-scales-3-line',
      title: 'Legal Services',
      description: 'Workflow optimization for case management, intake, and firm efficiency.',
      image: 'https://readdy.ai/api/search-image?query=modern%20law%20office%20with%20organized%20case%20files%20and%20digital%20systems%2C%20professional%20legal%20workspace%20with%20contemporary%20design%2C%20clean%20minimalist%20environment%20with%20technology%20integration%2C%20sophisticated%20business%20atmosphere&width=600&height=400&seq=industry-legal-001&orientation=landscape'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Financial Services',
      description: 'AI-assisted operations designed for advisors, accountants, and finance professionals.',
      image: 'https://readdy.ai/api/search-image?query=professional%20financial%20advisory%20office%20with%20modern%20analytics%20displays%2C%20clean%20contemporary%20workspace%20with%20financial%20charts%20and%20data%20visualization%2C%20sophisticated%20business%20environment%20with%20technology%2C%20organized%20professional%20atmosphere&width=600&height=400&seq=industry-finance-001&orientation=landscape'
    }
  ];

  return (
    <section id="industries" className="py-24 bg-soft-silver">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-5xl font-serif font-bold text-midnight-navy text-center mb-16">
          Industries We <span className="text-wealth-gold">Support</span>
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
          {industries.map((industry, index) => (
            <div key={index} className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-lg transition-all group cursor-pointer">
              <div className="h-48 overflow-hidden">
                <img 
                  src={industry.image} 
                  alt={industry.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <h3 className="text-lg font-semibold text-midnight-navy mb-3 group-hover:text-wealth-gold transition-colors">
                  {industry.title}
                </h3>
                <p className="text-sm text-slate-gray leading-relaxed">
                  {industry.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
